<template>
  <div class="wg-row">
    <div class="wg-row" style="flex-wrap:nowrap;">
      <div class="wg-row">
        <div v-if="msg.data.from" class="wg-row msg-row">
          <!-- icona piattaforma -->
          <img class="com-anm22-app-img-fixed-height-m" :src="''">
          <!-- numero o ID chiamante  -->
          <div class="com-anm22-app-text-m">
            {{ msg.data.from }}
          </div>
        </div>
        <div v-if="msg.data.callResponse && (msg.data.callResponse == 'notreplied' || msg.data.callResponse == 'notexist')">
          <div class="wg-row msg-row">
          <img class="com-anm22-app-img-fixed-height-s" 
            :src="$anm22.icons.getWorldIcon('arrowDownRight')" 
            style="margin-right:5px;">
          <img class="com-anm22-app-img-fixed-height-s" 
            style="margin-right:5px;"
            :src="$anm22.icons.getWorldIcon('phoneDisabled')" 
          >
          <div class="com-anm22-app-text-m">
            {{ msg.data.to }}
          </div>
          </div>
        </div>
        <div v-else>
          <div v-if="msg.data.to" class="wg-row msg-row">
            <!-- icona piattaforma -->
            <img class="com-anm22-app-img-fixed-height-s" 
                :src="$anm22.icons.getWorldIcon('arrowDownRight')" 
                style="margin-right:5px;">
            <!-- numero o ID chiamato  -->
            <div class="com-anm22-app-text-m">
              {{ msg.data.to }}
            </div>
          </div>
        </div>
      </div>
      <div class="display-flex" style="margin-left:auto;flex-direction:column;">
        <div class="hour">
          {{ msg.ts | moment('HH:mm') }}
        </div>
        <div class="time">
          {{ duration }}
        </div>
      </div>
    </div>
    <div class="wg-row msg-row description">
      <div v-html="$anm22.nl2br(msg.data.description)" class="com-anm22-app-text-m">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: Object
  },
  computed: {
    duration() {
      const moment = this.$moment.utc(this.$moment.duration(this.msg.data.duration, 'seconds').asMilliseconds());
      const format = [ 
        moment.hours() !== 0 ? 'H [h]' : '',
        moment.minutes() !== 0 ? 'm [min]' : '',
        moment.seconds() !== 0 ? 's [s]' : ''
      ].join(' ');
      return moment.format(format);
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.hour {
  padding: 4px 5px 0 0;
  font-size: 12px;
  margin-left: auto;
}
.time {
  padding: 3px 5px 0 0;
  font-size: 12px;
  margin-left: auto;
  opacity:0.5;
  white-space:nowrap;
}
.description {
  margin-top: 6px;
}
</style>
